
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor4 as ObiResistor4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-4.js';
 
 
 

 
 export const ObiResistor4 = createComponent({
   react: React,
   tagName: 'obi-resistor-4',
   elementClass: ObiResistor4Element,
   events: {
     
   }
  });
 
 